import axios from 'axios';
export var onenet = {
  ossInfo: function ossInfo() {
    return axios({
      url: "https://picture.thingcom.cn/web/token",
      method: 'get'
    }).then(function (response) {
      return response.data;
    }).catch(function (error) {
      console.log(error);
    });
  },
  datapoint: function datapoint(info) {
    return axios({
      url: "http://onenet.zn.thingcom.com/devices/".concat(info.id, "/datapoints?datastream_id=").concat(info.datastream_id),
      method: 'get',
      headers: {
        'api-key': info.apikey
      }
    }).then(function (response) {
      return response.data;
    }).catch(function (error) {
      console.log(error);
    });
  }
};